import { render } from "./HeroiconsSolidArrowUp.vue?vue&type=template&id=b2b5843e"
const script = {}

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowUp.vue"]])

export default __exports__